import { render } from "./TwitchFollowersList.vue?vue&type=template&id=738b7d66&scoped=true"
import script from "./TwitchFollowersList.vue?vue&type=script&lang=js"
export * from "./TwitchFollowersList.vue?vue&type=script&lang=js"

import "./TwitchFollowersList.vue?vue&type=style&index=0&id=738b7d66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738b7d66"]])

export default __exports__